

import {
  EpaysageBaseSaveInput,
  EpaysageEssenceActionInput,
  InventaireResponse,
} from '@repo/types';
import { AxiosInstance } from 'axios';
import { axiosInstance } from '../axios-instance';
import { ENDPOINTS } from '../endpoint';
import { BaseApiService } from './base-api.service';

export class EpaysageInventoryService extends BaseApiService {
  constructor(axios: AxiosInstance = axiosInstance) {
    super(ENDPOINTS.INVENTORY_EPAYSAGE.BASE, axios);
  }

  saveBase(payload: EpaysageBaseSaveInput): Promise<InventaireResponse> {
    return this.post<InventaireResponse, EpaysageBaseSaveInput>('/base', payload);
  }

  mutateEssence(payload: EpaysageEssenceActionInput): Promise<InventaireResponse> {
    return this.post<InventaireResponse, EpaysageEssenceActionInput>('/essence', payload);
  }
}

